<template>
    <div>
        <label
            v-if="field.label"
            class="font-weight-bold"
        >
            {{ field.label }}
            <span
                v-if="field.validators && field.validators.required"
                class="text-danger"
            >
                (required)
            </span>
        </label>
        <!--v-model="first_name" name="first_name"-->
        <b-form-input
            v-if="field.type == 'input'"
            class="form-control input-lg"
            v-model="field.value"
            :type="(field.subtype || 'text')"
            :placeholder="(field.placeholder || '')"
        ></b-form-input>
        <b-textarea
            v-else-if="field.type == 'textarea'"
            class="form-control input-lg"
            :placeholder="(field.placeholder || '')"
            v-model="field.value"
        ></b-textarea>
        <b-checkbox
            v-else-if="field.type == 'checkbox'"
            v-model="field.value"
        >
        </b-checkbox>
        <gender-input
            v-else-if="field.type == 'gender'"
            v-model="field.value"
        ></gender-input>
        <dt-picker
            v-else-if="field.type == 'dt-picker'"
            v-model="field.value"
        ></dt-picker> 
        <phone-input
            v-else-if="field.type == 'tel'"
            v-model="field.value"
        >
        </phone-input>
        <div
            v-else-if="field.type == 'p'"
        >
            <h3 v-if="field.heading">{{ field.heading }}</h3>
            {{ field.content }}
        </div>
        <b-input
            v-else
            :placeholder="(field.placeholder || '')"
            :type="field.type"
            :state="invalidFeedback"
            v-model="field.value"
        ></b-input>
        <div
            v-if="field.validators && field.value"
        >
            <div
                v-if="field.value.length > field.validators.maxLength"
                class="alert alert-danger mt-2"
            >
                <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
                {{ field.label || parent.label }} is too long!
            </div>
            <div
                v-else-if="field.value.length < field.validators.minLength"
                class="alert alert-danger mt-2"
            >
                <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
                {{ field.label || parent.label }} is too short!
            </div>
            <div
                v-else-if="(field.validators.contains && !field.value.includes(field.validators.contains))"
                class="alert alert-danger mt-2"
            >
                <font-awesome-icon icon="exclamation-triangle"></font-awesome-icon>
                {{ field.label || parent.label }} must contain "{{ field.validators.contains }}"
            </div>
        </div>
    </div>
</template>
<script>
import dtPicker     from "@/components/form/DateTimePicker.vue"
import GenderInput  from "@/components/form/GenderInput.vue"
import PhoneInput   from "@/components/form/PhoneInput.vue"

export default {
    name        :   "form-input",
    props       :   [
                        "parent",
                        "field"
                    ],
    methods     :   {
                        getInvalidFeedback(value)
                                {
                                    const field = this.field;
                                    if (field.validators) {
                                        if (value > field.validators.maxLength) {
                                            return `${field.label} is too long!`;
                                        }
                                    }
                                    return "''";
                                }  
                    },
    computed    :   {
                        invalidFeedback()
                                {
                                    const field = this.field;
                                    if (field.validators && field.value) {
                                        if  (field.value.length == 0) {
                                            return null;
                                        }
                                        else if  (
                                                field.value.length > field.validators.maxLength ||
                                                field.value.length < field.validators.minLength ||
                                                (field.validators.contains && !field.value.includes(field.validators.contains))
                                            ) {
                                                return false;
                                        }
                                        return true;
                                    }
                                    return null;
                                }
                    },
    components  :   {
                        dtPicker,
                        GenderInput,
                        PhoneInput
                    }
}
</script>